import React, { Component} from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import IconButton from 'material-ui/IconButton';
import Menu, { MenuItem } from 'material-ui/Menu';
import MoreVertIcon from 'material-ui-icons/MoreVert';
import { Link } from 'react-router';

class UserSponsorItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null
    }
  }
  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const
      {
        id,
        full_name,
        email,
        user_type,
        company_name,
        last_login,
        created_at,
        logins_count
      } = this.props.user;

    const ITEM_HEIGHT = 48;
    const is_checked = _.includes(this.props.user_ids, id);
    const { anchorEl } = this.state;

    return (
      <tr>
        <td>
          <p>
            <input
              type="checkbox"
              className="filled-in"
              id="filled-in-box10"
              key={id}
              checked={is_checked}
            />
            <label htmlFor="filled-in-box10"
                   onClick={() => this.props.checkedUserIds(id)}>
            </label>
          </p>
        </td>
        <td>{full_name}</td>
        <td>{email}</td>
        <td>{user_type}</td>
        <td>{company_name}</td>
        <td>{moment(created_at).format('D/M/YYYY')}
          <span>{moment(created_at).format('h:mm a').toUpperCase()}</span>
        </td>
        <td>
        { last_login &&
          <p>{moment(last_login).format('D/M/YYYY')}
            <span>{moment(last_login).format('h:mm a').toUpperCase()}</span>
          </p>
        }
        </td>
        <td>{logins_count}</td>
        <td>
          <IconButton
            className="table_more"
            aria-label="More"
            aria-owns={anchorEl ? 'long-menu' : null}
            aria-haspopup="true"
            onClick={this.handleClick}
          >
            <MoreVertIcon />
          </IconButton>
          <Menu
            id="long-menu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={this.handleClose}
            PaperProps={{
              style: {
                maxHeight: ITEM_HEIGHT * 4.5,
                width: 200,
              },
            }}
          >
            <Link to={`/users_sponsors/${id}/edit`}>

              <MenuItem >Edit</MenuItem>
            </Link>
          </Menu>
        </td>
      </tr>

    );
  }
}

UserSponsorItem.defaultProps = {};

UserSponsorItem.propTypes = {};

export default UserSponsorItem;



// WEBPACK FOOTER //
// ./src/components/Admin/UserSponsor/List/UserSponsorItem.jsx